import MAIL_STATUS from '../../constants-v2/crm/mailing-status';
import FiltersType from './listingFiltersTypesConstants';
import store from '../../store/store';

export default {
  path: '/mailing',
  filters: [
    {
      key: 'fulltext',
      placeholder: 'Wpisz frazę do znalezienia',
      shortPlaceholder: 'Szukaj',
      badge: 'Szukana fraza:',
      testName: 'hub_filter_search',
      inputType: FiltersType.TEXT_SEARCH_TYPE,
      reset: async () => ({ value: '' }),
    },
    {
      key: '_status',
      getItems: async () => [
        { value: MAIL_STATUS.SENT.KEY, label: MAIL_STATUS.SENT.TEXT },
        { value: MAIL_STATUS.PLANNED.KEY, label: MAIL_STATUS.PLANNED.TEXT },
        { value: MAIL_STATUS.READ.KEY, label: MAIL_STATUS.READ.TEXT },
        { value: MAIL_STATUS.ERROR.KEY, label: MAIL_STATUS.ERROR.TEXT },
      ],
      reset: async () => null,
      placeholder: 'Status',
      badge: 'Status',
      testName: 'test_filter_mailing_inbox_status',
      inputType: FiltersType.SELECT_TYPE,
    },
    {
      key: 'type',
      getItems: async () => [
        { value: 'MANUAL', label: 'ręczny' },
        { value: 'SYSTEM', label: 'systemowy' },
      ],
      reset: async () => null,
      placeholder: 'Typ',
      badge: 'Typ',
      testName: 'test_filter_mailing_type',
      inputType: FiltersType.SELECT_TYPE,
    },
    {
      key: '_dispatch_time_date',
      reset: async () => ({ value: { fromVal: null, toVal: null } }),
      placeholder: '',
      badge: 'Data zaplanowania:',
      testName: 'test_filter_mailing_dispatch_time',
      inputType: FiltersType.RANGE_TYPE,
      htmlInputType: 'date',
    },
    {
      key: 'company_name',
      reset: async () => null,
      placeholder: 'Adresat',
      badge: 'Adresat',
      testName: 'test_filter_mailing_company_name',
      inputType: FiltersType.TEXT_SEARCH_TYPE,
    },
    {
      key: 'title',
      reset: async () => null,
      placeholder: 'Tytuł wiadomości',
      badge: 'Tytuł wiadomości',
      testName: 'test_filter_mailing_title',
      inputType: FiltersType.TEXT_SEARCH_TYPE,
    },
    {
      key: 'is_group',
      getItems: async () => [
        { value: true, label: 'TAK' },
        { value: false, label: 'NIE' },
      ],
      reset: async () => null,
      placeholder: 'Grupowa',
      badge: 'Grupowa',
      testName: 'test_filter_mailing_is_group',
      inputType: FiltersType.SELECT_TYPE,
    },
    {
      key: '_show_only_mine',
      getItems: async () => [
        { value: 0, label: 'NIE' },
        { value: 1, label: 'TAK' },
      ],
      reset: async () => null,
      visible: () => !store.getters['auth/isUserCrm'],
      placeholder: 'Pokaż tylko moje',
      badge: 'Pokaż tylko moje:',
      testName: 'test_filter_mailing_inbox_show_only_mine',
      inputType: FiltersType.SELECT_TYPE,
    },
  ],
};
